const commentsData = [
  { name: '追剧小达人', time: '2小时前', rating: 5, content: '用了香蕉影视半年多了，真的秒开不卡！之前用别的平台缓冲半天，这个简直救了我的追剧命。画质也超清，投屏到电视上看太爽了！' },
  { name: '电影控阿杰', time: '5小时前', rating: 5, content: '片库真的全，连一些冷门老片都能找到。流浪地球2上线当天就能看，更新速度没得说。已经推荐给身边所有朋友了。' },
  { name: '剧荒拯救者', time: '8小时前', rating: 4, content: '榜单功能很实用，不知道看什么就去热播榜逛一圈。分类也很清晰，综艺、电视剧、电影分得很清楚，找片效率很高。' },
  { name: '深夜观影人', time: '1天前', rating: 5, content: '完全不收费这点太良心了！而且没有那些烦人的弹窗广告。晚上躺床上用手机看，清晰度足够，流量也不怎么费。' },
  { name: '综艺爱好者', time: '2天前', rating: 5, content: '综艺更新速度真的快，基本上电视播完第二天就有了。乘风破浪的姐姐每期都追，画质和音效都很棒，强烈推荐！' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">用户热评</h2>
          <p className="text-foreground-400 text-sm">来自真实用户的评价，口碑见证品质</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-[1100px] mx-auto">
          {commentsData.map((item, i) => (
            <div key={i} className={`p-5 rounded-xl bg-background-100 border border-background-300/40 ${i >= 3 ? 'lg:col-span-1' : ''}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-400 text-sm font-bold">{item.name.charAt(0)}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-foreground-100 text-sm">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className={`text-xs ${j < item.rating ? 'ri-star-fill text-primary-400' : 'ri-star-line text-foreground-600'}`}></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}